import { useQuery } from '@apollo/client';
import { GET_USER_FEATURES_QUERY } from './user-features.query';
import { GetUserFeatures_me_features } from './__graphqlTypes/GetUserFeatures';

// eslint-disable-next-line camelcase
export function useUserFeatures(): Omit<GetUserFeatures_me_features, '__typename'> {
    const result = useQuery(GET_USER_FEATURES_QUERY);
    return {
        dashboardV2: false,
        enableEmailTemplateDivider: false,
        enableEmailTemplatePlaceholder: false,
        enableEmailTemplateSpacer: false,
        enableNewConnectPage: false,
        showOldEmailTemplatesOption: false,
        templateGalleryV2: false,
        ...result.data?.me?.features,
    };
}
